<template>

    <!-- Ec Shop page -->
    <section class="ec-page-content section-space-p">
        <div class="container">
            <div class="row">
                <div class="ec-shop-rightside col-lg-9 order-lg-last col-md-12 order-md-first margin-b-30">
                    <!-- Shop Top Start -->
                    <div class="ec-pro-list-top d-flex">
                        <div class="col-md-6 d-flex px-2">
                            <span class="sort-by py-2 pe-2">{{ $t('Sort by') }}</span>
                            <div class="ec-select-inner">

                                <select class=""
                                        aria-label=""
                                        v-model="q.order" id="ec-select">
                                    <option :value="null" selected>
                                        {{ $t('Featured') }}
                                    </option>
                                    <option :value="{'by' : 'price' , 'direction' : 'DESC' , }">
                                        {{ $t('Price high to low') }}
                                    </option>
                                    <option :value="{'by' : 'price' , 'direction' : 'ASC' , }">
                                        {{ $t('Price low to high') }}
                                    </option>
                                </select>

                            </div>
                        </div>
                        <!--                        <div class="col-md-6 ec-grid-list">-->
                        <!--                            <div class="ec-gl-btn">-->
                        <!--                                <button class="btn btn-grid active"><i class="fi-rr-apps"></i></button>-->
                        <!--                                <button class="btn btn-list"><i class="fi-rr-list"></i></button>-->
                        <!--                            </div>-->
                        <!--                        </div>-->
                    </div>
                    <!-- Shop Top End -->

                    <!-- Shop content Start -->
                    <div class="shop-pro-content">
                        <div class="shop-pro-inner">
                            <div class="row"  v-if="items?.data?.length > 0">

                                <div class="col-lg-4 col-md-6 col-sm-6 col-6 mb-6 "
                                     v-for="product in items?.data" :key="product.id">
                                    <div class="ec-product-sbtn border rounded-3">
                                        <div class="ec-product-image">

                                            <router-link
                                                :to="{name: 'products.show', params: { id: product.id , lang : $i18n.locale  }}"
                                                class="ec-image">

                                                <img class="pic-1"
                                                     :src="product.image ?? '/images/spices-jar.jpeg'"
                                                     alt=""/>
                                                <img class="pic-2"
                                                     :src="product.image ?? '/images/spices-jar.jpeg'"
                                                     alt=""/>
                                            </router-link>

                                            <span class="ec-product-sale-label" v-if="product?.hot != false">الأكثر مبيعاً</span>
<!--                                            <span class="ec-product-discount-label" v-if="product?.discount != null">{{ product?.discount }}</span>-->

                                        </div>
                                        <div class="ec-product-body">
                                            <ul class="ec-rating">

                                                <li v-for="(star, index) in ( product?.avg_rating ?? 0 )" :key="index"
                                                   class="ecicon eci-star fill"></li>

                                                <li v-for="(star, index) in 5 - ( product?.avg_rating ?? 0)" :key="index"
                                                   class="ecicon eci-star-o"></li>

                                            </ul>

                                            <h3 class="ec-title">

                                                <router-link
                                                    :to="{name: 'products.show', params: { id: product.id , lang : $i18n.locale  }}">
                                                    {{ product?.name }}
                                                </router-link>

                                            </h3>
                                            <div class="ec-price">
                                                <del v-if="product?.old_price" class="text-muted">{{ product?.old_price}} {{ $t('SAR') }}</del>
                                                {{ product?.price_tax }} {{ $t('SAR') }}
                                            </div>
                                            <div class="ec-product-button-group">

                                                <favoriteIcon
                                                    :item="product"
                                                    @update:item="product.favorite = $event.favorite"
                                                    :theme="'ec-product-like-icon'">

                                                </favoriteIcon>
                                                <!--                                                <a class="ec-product-like-icon" href="#"><i class="fi-rr-heart"></i></a>-->
                                                <!--                                                <a class="ec-add-to-cart" href="#">ADD TO CART</a>-->

                                                <CartButton :product="product" v-if="product?.id != null" :type="'ec-link-btn'"></CartButton>

                                                <!--                                                <a class="ec-product-compare-icon" href="#"><i class="fi fi-rr-arrows-repeat"></i></a>-->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-else class="alert alert-info p-2">
                                لا يوجد منتجات ضمن نتائج البحث.
                            </div>
                        </div>


                        <!-- Ec Pagination Start -->
                        <div class="ec-pro-pagination">
                            <span> </span>

                            <Bootstrap5Pagination
                                class="m-2"
                                :data="items"
                                :limit="2"
                                :show-disabled="false"
                                :size="'default'"
                                :align="'center'"
                                @pagination-change-page="getResults"
                            />
                        </div>


                        <!-- Ec Pagination End -->
                    </div>
                    <!--Shop content End -->
                </div>
                <!-- Sidebar Area Start -->
                <div class="ec-shop-leftside col-lg-3 order-lg-first col-md-12 order-md-last">
                    <div id="shop_sidebar">
                        <div class="ec-sidebar-heading">
                            <h1>البحث وتصفية المنتجات : </h1>
                        </div>
                        <div class="ec-sidebar-wrap">

                            <div class="form-floating theme-form-floating-2 mb-3">
                                <input type="search" class="form-control" id="search"
                                       :placeholder="$t('input_search')" v-debounce:400ms="setName" :value="q.name">
                                <label for="search">{{ $t('Product name') }}</label>
                            </div>

                            <!-- Sidebar Category Block -->
                            <div class="ec-sidebar-block">
                                <div class="ec-sb-title">
                                    <h3 class="ec-sidebar-title"> {{ $t('By category') }} </h3>
                                </div>
                                <div class="ec-sb-block-content ms-2">
                                    <ul>
                                        <!-- <li >-->
                                        <!--     <div class="form-check ps-0 m-0 category-list-box">-->
                                        <!--         <label class="form-check-label" :for="'category-' + category.id">-->
                                        <!--             <span class="name">-->
                                        <!--                 <img v-if="category.icon != null" :src="category.icon" width="23" />-->
                                        <!--                 -->
                                        <!--             </span>-->
                                        <!--         </label>-->
                                        <!--     </div>-->
                                        <!-- </li>-->

                                        <!--                                        <li v-for="category in main?.categories">-->
                                        <!--                                            <div class="ec-sidebar-block-item">-->

                                        <!--                                                <input type="checkbox"-->
                                        <!--                                                       v-model="q.category_ids" :value="category.id" :id="'category-' + category.id">-->

                                        <!--                                                <a href="#"> {{ category?.name }} </a>-->
                                        <!--                                                <span class="checked"></span>-->
                                        <!--                                            </div>-->
                                        <!--                                        </li>-->
                                        <li v-for="section in main?.sections">
                                            <div class="ec-sidebar-block-item">

                                                <input type="checkbox"
                                                       v-model="q.section_ids" :value="section.id"
                                                       :id="'section-' + section.id">

                                                <a href="#"> {{ section?.name }} </a>
                                                <span class="checked"></span>
                                            </div>
                                            <ul class=" ms-4 mt-3 p-2" v-if="section?.categories?.length > 0">

                                                <li v-for="category in section?.categories">
                                                    <div class="ec-sidebar-block-item">

                                                        <input type="checkbox"
                                                               v-model="q.category_ids" :value="category.id"
                                                               :id="'category-' + category.id">

                                                        <a href="#"> {{ category?.name }} </a>
                                                        <span class="checked"></span>
                                                    </div>
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <!-- Sidebar Price Block -->
                            <!--                            <div class="ec-sidebar-block">-->
                            <!--                                <div class="ec-sb-title">-->
                            <!--                                    <h3 class="ec-sidebar-title">Price</h3>-->
                            <!--                                </div>-->
                            <!--                                <div class="ec-sb-block-content es-price-slider">-->
                            <!--                                    <div class="ec-price-filter">-->
                            <!--                                        <div id="ec-sliderPrice" class="filter__slider-price" data-min="0"-->
                            <!--                                             :data-max="max_price" data-step="10"></div>-->
                            <!--                                        <div class="ec-price-input">-->

                            <!--                                            <label class="filter__label"><input type="text"-->
                            <!--                                                                                class="filter__input" @input="onPriceInput()" v-model="this.q_price.from"></label>-->

                            <!--                                            <span class="ec-price-divider"></span>-->

                            <!--                                            <label class="filter__label"><input type="text"-->
                            <!--                                                                                class="filter__input"  @input="onPriceInput()" v-model="this.q_price.to"></label>-->

                            <!--                                        </div>-->
                            <!--                                    </div>-->
                            <!--                                </div>-->
                            <!--                            </div>-->


<!--                            <div class="ec-sidebar-block">-->
<!--                                <div class="ec-sb-title">-->
<!--                                    <h3 class="ec-sidebar-title"> {{ $t('Price') }} </h3>-->
<!--                                </div>-->
<!--                                <div class="ec-sb-block-content ms-2">-->

<!--                                    <div class="d-flex ">-->
<!--                                        <div class="d-flex me-1 ">-->
<!--                                            <label class="input-group-text border-0 px-1 bg-transparent"-->
<!--                                                   for="price-from">-->
<!--                                                {{ $t('From') }}-->
<!--                                            </label>-->
<!--                                            <input class="form-control ps-2" type="number" id="price-from"-->
<!--                                                   @input="onPriceInput()" v-model="this.q_price.from">-->
<!--                                            <label class="input-group-text  px-1 border-0 bg-transparent"-->
<!--                                                   for="price-to">-->
<!--                                                {{ $t('To') }}-->
<!--                                            </label>-->
<!--                                            <input class="form-control ps-2" type="number" id="price-to"-->
<!--                                                   @input="onPriceInput()" v-model="this.q_price.to">-->
<!--                                        </div>-->
<!--                                        &lt;!&ndash;                                        <a class="btn btn-sm btn-link" @click="q.price = q_price">عرض</a>&ndash;&gt;-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->


                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- End Shop page -->

    <!--        &lt;!&ndash; Shop Section Start &ndash;&gt;-->
    <!--        <section class="section-b-space shop-section">-->
    <!--            <div class="container-fluid-lg">-->
    <!--                <div class="row">-->
    <!--                    <div class="col-custome-3 wow fadeInUp">-->
    <!--                        <div class="left-box">-->
    <!--                            <div class="shop-left-sidebar">-->
    <!--                                <div class="back-button">-->
    <!--                                    <h3>-->
    <!--                                        <i class="fa-solid fa-arrow-left"></i> {{ $t('Back') }}-->
    <!--                                    </h3>-->
    <!--                                </div>-->

    <!--                                <div class="accordion custome-accordion" id="accordionExample">-->

    <!--                                </div>-->
    <!--                            </div>-->
    <!--                        </div>-->
    <!--                    </div>-->

    <!--                    <div class="col-custome-9 wow fadeInUp">-->
    <!--                        <div class="show-button">-->

    <!--                            <div class="top-filter-menu mt-0 w-100  d-flex  justify-content-between">-->
    <!--                                <div class="category-dropdown">-->
    <!--                                </div>-->


    <!--&lt;!&ndash;                                <div class="category-dropdown">&ndash;&gt;-->
    <!--&lt;!&ndash;                                    <h5 class="text-content">{{ $t('Sort by') }} :</h5>&ndash;&gt;-->
    <!--&lt;!&ndash;                                    <div class="dropdown">&ndash;&gt;-->
    <!--&lt;!&ndash;                                        <button class="dropdown-toggle" type="button" id="dropdownMenuButton1"&ndash;&gt;-->
    <!--&lt;!&ndash;                                                data-bs-toggle="dropdown">&ndash;&gt;-->
    <!--&lt;!&ndash;                                            <span> </span> <i class="fa-solid fa-angle-down"></i>&ndash;&gt;-->
    <!--&lt;!&ndash;                                        </button>&ndash;&gt;-->
    <!--&lt;!&ndash;                                        <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">&ndash;&gt;-->
    <!--&lt;!&ndash;                                            <li>&ndash;&gt;-->
    <!--&lt;!&ndash;                                                <a class="dropdown-item" id="pop"&ndash;&gt;-->
    <!--&lt;!&ndash;                                                   href="javascript:void(0)"  @click="q.order = null">&ndash;&gt;-->
    <!--&lt;!&ndash;                                                    الخيارات المميزة&ndash;&gt;-->
    <!--&lt;!&ndash;                                                </a>&ndash;&gt;-->
    <!--&lt;!&ndash;                                            </li>&ndash;&gt;-->
    <!--&lt;!&ndash;                                            <li>&ndash;&gt;-->
    <!--&lt;!&ndash;                                                <a class="dropdown-item" id="low"&ndash;&gt;-->
    <!--&lt;!&ndash;                                                   href="javascript:void(0)" @click="q.order = {'by' : 'price' , 'direction' : 'DESC' , }">&ndash;&gt;-->
    <!--&lt;!&ndash;                                                    السعر الأعلى أولاً&ndash;&gt;-->
    <!--&lt;!&ndash;                                                </a>&ndash;&gt;-->
    <!--&lt;!&ndash;                                            </li>&ndash;&gt;-->
    <!--&lt;!&ndash;                                            <li>&ndash;&gt;-->
    <!--&lt;!&ndash;                                                <a class="dropdown-item" id="low"&ndash;&gt;-->
    <!--&lt;!&ndash;                                                   href="javascript:void(0)" @click="q.order = {'by' : 'price' , 'direction' : 'ASC' , }">&ndash;&gt;-->
    <!--&lt;!&ndash;                                                    السعر الأقل أولاً&ndash;&gt;-->
    <!--&lt;!&ndash;                                                </a>&ndash;&gt;-->
    <!--&lt;!&ndash;                                            </li>&ndash;&gt;-->
    <!--&lt;!&ndash;                                        </ul>&ndash;&gt;-->
    <!--&lt;!&ndash;                                    </div>&ndash;&gt;-->
    <!--&lt;!&ndash;                                </div>&ndash;&gt;-->


    <!--                                <div class="filter-button-group mt-0">-->
    <!--                                    <div class="filter-button d-inline-block d-lg-none">-->
    <!--                                        <a>-->
    <!--                                            <i class="fa-solid fa-filter"></i>-->
    <!--&lt;!&ndash;                                            {{ $t('Filter Menu')}}&ndash;&gt;-->
    <!--                                        </a>-->
    <!--                                    </div>-->
    <!--                                </div>-->

    <!--                                <div class="grid-option d-none d-md-block">-->
    <!--                                    <ul>-->
    <!--                                        <li class="three-grid">-->
    <!--                                            <a href="javascript:void(0)">-->
    <!--                                                <img src="/theme/assets/svg/grid-3.svg" class="blur-up lazyload" alt="">-->
    <!--                                            </a>-->
    <!--                                        </li>-->
    <!--                                        <li class="grid-btn d-xxl-inline-block d-none active">-->
    <!--                                            <a href="javascript:void(0)">-->
    <!--                                                <img src="/theme/assets/svg/grid-4.svg"-->
    <!--                                                     class="blur-up lazyload d-lg-inline-block d-none" alt="">-->
    <!--                                                <img src="/theme/assets/svg/grid.svg"-->
    <!--                                                     class="blur-up lazyload img-fluid d-lg-none d-inline-block" alt="">-->
    <!--                                            </a>-->
    <!--                                        </li>-->
    <!--                                        <li class="list-btn">-->
    <!--                                            <a href="javascript:void(0)">-->
    <!--                                                <img src="/theme/assets/svg/list.svg" class="blur-up lazyload" alt="">-->
    <!--                                            </a>-->
    <!--                                        </li>-->
    <!--                                    </ul>-->
    <!--                                </div>-->
    <!--                            </div>-->
    <!--                        </div>-->


    <!--                    </div>-->
    <!--                </div>-->
    <!--            </div>-->
    <!--        </section>-->
    <!--        &lt;!&ndash; Shop Section End &ndash;&gt;-->
    <!--    </div>-->
</template>

<script>

import {useToast} from "vue-toastification";

const toast = useToast();
import Utility from "../../utility";

import {Bootstrap5Pagination} from 'laravel-vue-pagination'
import CartButton from "../cart_item/CartButton.vue";
import favoriteIcon from "./favorite-icon.vue";

export default {
    props: ['main'],
    components: {
        favoriteIcon,
        CartButton,
        Bootstrap5Pagination
    },
    watch: {
        'lastExecutionTime': { // Auto search
            handler:  function (newValue) {

                console.log('----lastExecutionTime');
                console.log(newValue);
            }
        },
        'q': { // Auto search
            handler:  function (newValue) {

                // التحقق من مرور مدة الفترة قبل تنفيذ الكود مرة أخرى
                const currentTime = Date.now();
                console.log(this.lastExecutionTime);
                console.log(this.cooldownDuration);

                if (currentTime - this.lastExecutionTime >= this.cooldownDuration) {
                    this.getResults(this.$route?.query?.page ?? 1);
                    // تحديث وقت آخر تنفيذ الكود
                    this.lastExecutionTime = currentTime;
                    console.log('---handler');
                }

                // if(this.stop_watch_q == false){
                //     console.log('---handler');
                //     this.getResults(1);
                //     // this.getResults(this.$route?.query?.page ?? 1);
                // }
            },
            deep: true
        }
    },
    data() {
        return {
            lastExecutionTime: 0, // تخزين وقت آخر تنفيذ للكود
            cooldownDuration: 5000, // مدة الفترة بالمللي ثانية (هنا 5000 مللي ثانية = 5 ثواني)

            // stop_watch_q: true, // عشان ميحملش اول ما الصفحة تبتدى عشان مشكلة ال page
            getResultsOnCreate: true,
            max_price: 1000,
            debounceTimer: null,
            items: [],
            q_price: {
                from: null,
                to: null
            },
            q: {
                order: null,
                price: {
                    from: null,
                    to: null
                },
                category_ids: [],
                section_ids: [],
                // occasion_ids : [],
                quantities: {
                    from: null,
                    to: null
                },
                ...this.$route.query,
            },
            form_options: {},
        }
    },
    async created() {
        console.log('---created');
        // console.log(this.$route?.query);
        // console.log(this.$route?.query?.length);
        //
        // const numberOfQueryKeys = Object.keys(this.$route?.query || {}).length;
        // console.log(numberOfQueryKeys);

        this.removeArrayQueries(this.q);

        if (this.getResultsOnCreate) {
            await this.getResults(this.$route?.query?.page ?? 1);
        }

        await this.themeJs();
        // this.stop_watch_q = false;
        // this.getResults(this.$route?.query?.page ?? 1);
    },
    methods: {
        removeArrayQueries(dataObject) {
            // const that = this;
            // Function to remove array-based query parameters from the 'q' data object
            console.log('removeArrayQueries');
            for (const key in dataObject) {
                const matches = key.match(/(\w+)\[(\d*)\]/);

                if (
                    matches !== null
                ) {

                    const new_key = matches[1];
                    // console.log(new_key);
                    console.log(typeof dataObject[key]);

                    // push new value  to dataObject[new_key] or create new if not exists and push
                    if (Array.isArray(dataObject[new_key])) {
                        dataObject[new_key].push(dataObject[key]);
                        this.getResultsOnCreate = false;
                    } else {
                        dataObject[new_key] = [dataObject[key]];
                        this.getResultsOnCreate = false;
                    }
                    delete dataObject[key];
                }
            }
            return dataObject;
        },
        setName(val) {
            this.q.name = val;
        },
        themeJs() {

            (function ($) {
                "use strict";

                /*=====================
                02. Shop Page Grid Setting Js
                ==========================*/
                $(".grid-option li").on("click", function () {
                    $(this).addClass('active').siblings().removeClass('active');
                });
                $(".grid-option .grid-btn").on("click", function () {
                    $(".product-list-section").removeClass("list-style");
                });
                $(".grid-option .list-btn").on("click", function () {
                    $(".product-list-section").addClass("list-style");
                });
                $('.three-grid').on('click', function (e) {
                    $(".product-list-section").removeClass("row-cols-xxl-5 row-cols-xxl-4 row-cols-xl-3 row-cols-lg-2 row-cols-md-3 row-cols-2 list-style").addClass("row-cols-xl-3 row-cols-lg-2 row-cols-md-3 row-cols-2");
                });
                $('.grid-btn').on('click', function (e) {
                    $(".product-list-section").removeClass("row-cols-xxl-5 row-cols-xxl-4 row-cols-xl-3 row-cols-lg-2 row-cols-md-3 row-cols-2 list-style").addClass("row-cols-xxl-4 row-cols-xl-3 row-cols-lg-2 row-cols-md-3 row-cols-2");
                });
                $('.five-grid').on('click', function (e) {
                    $(".product-list-section").removeClass("list-style").addClass("row-cols-xxl-5 row-cols-xl-3 row-cols-lg-2 row-cols-md-3 row-cols-2");
                });
                var contentwidth = $(window).width();
                if (contentwidth < "1199") {
                    $(".grid-options ul .grid-btn").addClass("active");
                }
                if (contentwidth < "1399") {
                    $(".grid-options ul .three-grid").addClass("active");
                }
            })(jQuery);

            /**=====================
             Filter Sidebar js
             ==========================**/
            $(".filter-button").click(function () {
                console.log('---- filter-button');
                $(".bg-overlay, .left-box").addClass("show");
            });
            $(".back-button, .bg-overlay").click(function () {
                $(".bg-overlay, .left-box").removeClass("show");
            });

            $(document).ready(function () {
                $(".sort-by-button").click(function () {
                    $(".top-filter-menu").toggleClass("show");
                });
            });
        },
        onPriceInput() {
            // Clear the previous timer if exists
            if (this.debounceTimer) {
                clearTimeout(this.debounceTimer);
            }
            // Set up a new timer to call the handler after 500ms (adjust the time as needed)
            this.debounceTimer = setTimeout(() => {

                // Perform actions or update the filter based on the provided values
                // For example, you can emit an event to notify the parent component of the changes.
                this.q.price = {
                    'from': this.q_price.from,
                    'to': this.q_price.to,
                };
            }, 500); // Adjust the delay time (in milliseconds) as needed
        },
        async getResults(page) {
            console.log('getResults <---');

            const id = toast.info(this.$t('Getting content ...'), {icon: 'fa-light fa-filter-list'});


            const _params = { // دي بتأثر فى watch لل q
                ...this.q,
                page: page,
            };

            let form_params = Utility.convertModelToFormData(_params);

            await axios.get('products', {params: form_params}).then(response => {
                toast.dismiss(id);
                this.items = response.data;
                this.max_price = response.data?.max_price ?? 1000;

                this.$router.replace({
                    name: "products.index",
                    query: form_params , params: { lang : this.$i18n.locale }
                });
                console.log('replace <---');

            }, response => {
                toast.dismiss(id);
            });

        },
    }
}
</script>
